import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService} from '../../../services/account.service';
import {AvailableStatements} from '../../../domain/accounts/available-statements';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import * as FileSaver from 'file-saver';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {ConfigurationService} from '../../../services/configuration.service';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';


@Component({
  selector: 'app-account-statement',
  templateUrl: './account-statement.component.html',
  styleUrls: ['./account-statement.component.scss']
})
export class AccountStatementComponent extends CommonComponent implements OnInit, OnDestroy {
  availableStatements: AvailableStatements[] = [];
  minDate: Date;
  maxDate: Date;
  today = moment();
  activationDate = moment('2021/01/01', 'YYYY/MM/DD');
  date: Date;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private accountsService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private customerProfileService: CustomerProfileService,
    private configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
    this.today.startOf('month');
    this.maxDate = this.today.clone().subtract(1, 'months').toDate();
    this.minDate = this.today.clone().subtract(this.configurationService.account.statementsMaxDaysQueryPeriod, 'days')
      .startOf('month').toDate();
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        const approvalDate = moment(response.approvalDate).startOf('month');
        if (approvalDate.toDate() > this.minDate) {
          this.minDate = approvalDate.toDate();
        }

      }, error => {

      }
    );
  }

  getAvailableStatements(date: Date) {
    this.loadingModalOn();
    const statementDate = moment(date);
    const formattedDate = statementDate.format('YYYY-MM');

    this.accountsService.getStatementMonthly(formattedDate).subscribe(
      (response) => {
        const file = new Blob([response], {type: 'application/pdf'});

        const URL_FILE = URL.createObjectURL(file);
        
        let pdfWindow = window.open();
        if (pdfWindow) {
          pdfWindow.location.href = URL_FILE;
        }

        FileSaver.saveAs(file, `statement_${formattedDate}.pdf`);
        this.loadingModalOff();
        
      }, error => {
        try {
          const textDecoder = new TextDecoder('utf-8');
          const errorText = textDecoder.decode(error.error);
          error.error = JSON.parse(errorText);
          this.msgError(error);
        } catch (e){
          error.error = {
            message: this.translate.instant('accounts.account_statement.error')
          };
          this.msgError(error);
        }
        this.loadingModalOff();
      }
    );
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}
